import { h } from '@/lib/dom';

export interface PdfLinkProps {
  href: string;
  label: string;
  fileSize?: string;
}

export function PdfLink(props: PdfLinkProps): HTMLAnchorElement {
  return h(
    'a',
    {
      href: props.href,
      target: '_blank',
      rel: 'noopener',
      'data-external': 'true',
      class: 'pdf-link',
      aria: { label: `Открыть PDF: ${props.label}` },
    },
    [
      h('span', { 'aria-hidden': 'true' }, '📄 '),
      h('span', null, props.label),
      props.fileSize ? h('span', { class: 'text-tertiary', style: 'margin-left:8px;' }, props.fileSize) : null,
      h('span', { class: 'chevron text-tertiary', style: 'margin-left:4px;' }, '→'),
    ],
  );
}
